import Http from '../http'

export const index = (page, search) => Http.get(`/blogs/content?page=${page}&search=${search}`, { headers: { Authorization: localStorage.token } })
export const show = (id) => Http.get(`/blogs/content/${id}`, { headers: { Authorization: localStorage.token } })
export const store = (data) => Http.post('/blogs/content', data, { headers: { Authorization: localStorage.token } })
export const update = (id, data) => Http.patch(`/blogs/content/${id}`, data, { headers: { Authorization: localStorage.token } })
export const destroy = (id) => Http.delete(`/blogs/content/${id}`, { headers: { Authorization: localStorage.token } })
